var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SNS Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 4965"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    d: "M12.002 4C12.0129 4 18.8797 4.00053 20.5977 4.46582C21.5446 4.71807 22.2897 5.46721 22.542 6.42188C22.9999 8.14891 22.9961 11.75 22.9961 11.75C22.9961 11.7752 22.9944 15.3573 22.5381 17.0781C22.2858 18.0289 21.5407 18.7781 20.5938 19.0342C18.8781 19.4959 11.998 19.4961 11.998 19.4961C11.9875 19.4961 5.11662 19.4956 3.40234 19.0342C2.45544 18.7819 1.71026 18.0328 1.45801 17.0781C1.00169 15.3573 1.00001 11.7752 1 11.75C1 11.75 1.00016 8.14887 1.46191 6.41797C1.71416 5.46718 2.45935 4.71804 3.40625 4.46191C5.12178 4.00014 12.002 4 12.002 4ZM9.75098 15.0215L15.502 11.75L9.75098 8.47852V15.0215Z",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.caa2a5a6e1011f1bae461cbb3c2142e3.svg";
export { ForwardRef as ReactComponent };